import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

import type { EmailQuerySchema, EmailsMutationSchema } from './schema';

export const useCreateMutation = () =>
  useMutation<{ data: EmailQuerySchema }, ApiError, Omit<EmailsMutationSchema, 'id'>>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/emails/`,
        payload,
      }),
  });

export const useUpdateMutation = () =>
  useMutation<{ data: EmailQuerySchema }, ApiError, EmailsMutationSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/emails/${payload.id}`,
        method: 'PUT',
        payload,
      }),
  });

export const useDeleteMutation = () =>
  useMutation<unknown, unknown, { id: string }>({
    mutationKey: ['EMAIL_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/emails/${id}`,
        method: 'DELETE',
      }),
  });
